/**
 * cartBuyerIdentityUpdate.js — GraphQL mutation to associate buyer identity with a Shopify cart.
 * Used in Attendees.js to attach the logged-in customer's email/phone to the cart.
 */
import gql from "graphql-tag";

export const cartBuyerIdentityUpdate = gql`
mutation cartBuyerIdentityUpdate($checkoutId: ID!, $buyerIdentityInput: CartBuyerIdentityInput!) {
  cartBuyerIdentityUpdate(cartId: $checkoutId, buyerIdentity: $buyerIdentityInput) {
    cart {
      id
      buyerIdentity {
        email
        phone
        countryCode
        customer {
          id
        }
      }
    }
  }
}
  `;